<template>
  <!-- <div v-if="additionalMaterialTypeCopy"> -->
    <b-modal :id="modalId" 
             :title="title"
             v-model="showModal"
             hide-footer
             @hide="hideModal">

      <!-- add v-for here for various components -->
      <div v-for="(option, index) in additionalMaterialTypeCopy.additionalMaterialTypeOptions" 
          :key="option.additionalMaterialTypeOptionId"
          v-show="step === index">
        <dynamic-wrapper :component-name="option.additionalMaterialOption.name" @submitted="next()" @previous="previous()" 
          :option="option.additionalMaterialOption"
          v-bind:studentOpportunityAdditionalMaterialId="studentOpportunityAdditionalMaterialId"
          v-bind:studentOpportunityId="studentOpportunityCopy.studentOpportunityId"
          :asuriteId="userId"
          :callback="option.onSubmitAction"
          :isFirst="index == 0"
          :isLast="index == additionalMaterialTypeCopy.additionalMaterialTypeOptions.length - 1"></dynamic-wrapper>
      </div>
    </b-modal>
  <!-- </div> -->
</template>

<script>
import { mapActions } from "vuex";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import dynamicWrapper from "../placements/dynamic-wrapper";

export default {
  data() {
    return {
      // make a copy to avoid mutating props
      additionalMaterialTypeCopy: {},
      studentOpportunityAdditionalMaterialCopy: null,
      studentOpportunityCopy: null,
      step: 0,
      standalone: true
    };
  },

  components: {
    "dynamic-wrapper": dynamicWrapper
  },

  props: {
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    userId: {
      required: true,
      type: String
    },
    additionalMaterialType: {
      type: Object,
      required: true
    },
    studentOpportunity: {
      required: false,
      type: Object,
      default: function() {
        return { studentOpportunityId: 0 };
      }
    },
    studentOpportunityAdditionalMaterial: {
      required: false,
      type: Object
    },
    studentOpportunityAdditionalMaterialId: {
      required: false,
      type: Number,
      default: 0
    },
    show: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(show) {
        return show;
      }
    }
  },

  methods: {
    ...mapActions("additionalMaterials", [
      "setGoals",
      "setUserId",
      "setStudentOpportunityId",
      "setStudentOpportunityAdditionalMaterialId",
      "setContact",
      "setStudentOpportunity",
      "setStudentOpportunityAdditionalMaterial",
      "setSupervisors",
      "reset"
    ]),
    next: function() {
      if (
        this.step + 1 <
        this.additionalMaterialType.additionalMaterialTypeOptions.length
      ) {
        this.step++;
      } else {
        // Toastr Message
        toastr.options = ToastrSettings;
        toastr.success("Submitted successfully.", "Success");
        this.hideModal();

        if (this.standalone) {
          this.$router.push({
            name: "studentOpportunityDetails",
            params: {
              id: this.$store.state.additionalMaterials.studentOpportunity
                .opportunity.opportunityId,
              studentOpportunityId: this.$store.state.additionalMaterials
                .studentOpportunityId
            }
          });
        } else {
          this.$emit("task-complete");
        }
      }
    },
    previous: function() {
      if (this.step > 0) {
        this.step--;
      }
    },
    hideModal: function() {
      this.step = 0;
      this.$emit("hideModal", { id: this.modalId });
    }
  },

  watch: {
    additionalMaterialType: function() {
      this.additionalMaterialTypeCopy = this.additionalMaterialType;
    },
    studentOpportunity: function() {
      this.studentOpportunityCopy = this.studentOpportunity;
      this.standalone = false;
    }
  },

  created() {
    this.reset();
    this.studentOpportunityCopy = this.studentOpportunity;
    this.studentOpportunityAdditionalMaterialCopy = this.studentOpportunityAdditionalMaterial;
    this.additionalMaterialTypeCopy = this.additionalMaterialType;
    this.setStudentOpportunity(this.studentOpportunityCopy);

    if (this.studentOpportunity.studentOpportunityId != 0) {
      this.standalone = false;
    }
  }
};
</script>

<style scoped>
h5 {
  font-size: 0.9em;
}

label {
  font-weight: bold;
}

.form-control-file {
  width: 70%;
}

.flex-float-right {
  margin-left: auto;
}

.invalid-label {
  color: #dc3545;
}

.alert-success {
  width: 100%;
}

.accordion-control {
  width: 100%;
  text-align: center;
  background-color: #e9e9e9;
  border: 1px solid #d1d2d3;
  margin-top: 1em;
}
</style>
